import httpRequest from '../request/indexBase'

// 新增工作流
export function addWorkFlowApi(data) {
  return httpRequest.post({
    url: `/workflow/workflow-info`,
    data
  })
}

// 编辑工作流
export function editWorkFlowApi(data) {
  return httpRequest.put({
    url: `/workflow/workflow-info`,
    data
  })
}

// 分享工作流
export function shareWorkflowApi(data) {
  return httpRequest.post({
    url: `/workflow/wf-hotspot-config/page`,
    data
  })
}

// 删除工作流
export function deleteWorkFlowApi(params) {
  return httpRequest.delete({
    url: `/workflow/workflow-info`,
    params
  })
}

// 复制工作流
export function copyWorkFlowApi(data) {
  return httpRequest.post({
    url: `/workflow/exec/createByTemplate`,
    data
  })
}

// 复制工作流（新版本）
export function copyWorkFlowNewApi(data) {
  return httpRequest.post({
    url: `/workflow/exec/copy`,
    data
  })
}

// 删除运行记录
export function deleteWorkFlowExecuteRecordApi(params) {
  return httpRequest.delete({
    url: `/workflow/workflow-execute-record`,
    params
  })
}

// 查询工作流是否重名
export function getIsDuplicateNameApi(params) {
  return httpRequest.get({
    url: `/workflow/workflow-info/getIsDuplicateName`,
    params
  })
}

// 查询会话展示模型
export function getDialogueModelList(params) {
  return httpRequest.get({
    url: `/workflow/model/getDialogueModelList`,
    params
  })
}
